import React, { useState, useEffect } from 'react';
import CreateFirmware from '../../components/CreateFirmware';
import useApi from '../../api/useApi';

const FirmWare = () => {
  const [{ isLoading, isError, data }, getFirmware] = useApi();
  const [firmware, setFirmware] = useState([]);
  const [uploadFirmware, setUploadFirmware] = useState(false);
  const day = 1000 * 60 * 60 * 24;
  useEffect(() => {
    getFirmware('/firmware', 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      const firmwareFile = [];
      const fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gim;
      data.firmwares.map((x, i) => {
        // console.log("x.Key.match(/.[0-9a-z]+$/i)[0] === '.ua'", x.Key.match(fileExtensionPattern) !== null && x.Key.match(fileExtensionPattern)[0] === '.ua');
        if (x.Key.match(fileExtensionPattern) !== null) {
          if (x.Key.match(fileExtensionPattern)[0] === '.ua' || x.Key.match(fileExtensionPattern)[0] === '.bin') {
            firmwareFile.push(x);
          }
        }
      });
      setFirmware(firmwareFile);
    }
  }, [isLoading, isError, data]);

  const refreshList = () => {
    getFirmware('/firmware', 'GET');
  };

  const toggleOpenFirmware = () => {
    setUploadFirmware((prev) => !prev);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime();
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000,
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;

    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  return (
    <div>
      {uploadFirmware && <CreateFirmware handleClose={toggleOpenFirmware} refreshList={() => refreshList()} />}
      <div className="mt-10 md:mt-0 lg:m-8 static md:fixed bg-white w-full sm:w-10/12 overflow-scroll lg:overflow-hidden firm_main">
        <div className="h-16 sm:h-40">
          <div
            className=" pt-4 md:pt-8 lg:flex block sm:block sm:justify-between text-left sm:text-center lg:text-left w-tableWidth m-auto "
            // style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-lg">Firmware</span>

            <div className="flex mt-0 float-right">
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-max border px-3 py-1 rounded-md text-xs mx-0 sm:mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  toggleOpenFirmware();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                UPLOAD
              </button>
            </div>
          </div>
        </div>
        <div className="tbl">
          <div className="bg-white w-tableWidth m-auto mb-3" style={{ minWidth: '900px' }}>
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-5 items-center flex w-full relative bg-primary text-white text-left text-xs font-bold">
                <div className="w-3/5 ">FIRMWARE</div>
                <div className="w-1/5">LAST UPLOADED</div>
                <div className="w-1/5">ACTION</div>
                {/* <img src="assets/img/Filter.svg" className="w-5 absolute top-5 right-3" /> */}
              </div>
            </div>
            <div className="hideScroll" style={{ overflowY: 'scroll', height: '68vh' }}>
              {firmware.map((item, idx) => {
                const modified = getTimeoffset(item?.LastModified);
                return (
                  <div
                    className="my-1 px-8 flex
                  relative hover:border-indigo-200 focus-within:border-indigo-200 text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs boxsize"
                  >
                    <div className="w-3/5">{item?.Key}</div>
                    <div className="w-1/5">{modified}</div>
                    <div className="w-1/5 flex">
                      <img
                        src="assets/img/Delete2.svg"
                        className="h-3"
                        alt=""
                        onClick={() => {
                          // selectDevice({ id: item?.id });
                          // selectOrg({ id: item?.id, name: item?.organizationName});
                          // setOnClose(true);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirmWare;
